// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1347":"6ad137307078f208","8012":"4027fe371745009b"}[chunkId] + ".css";
};